<template>
  <el-dialog id="popup_dialog" title="Produse" :visible.sync="showPopup" class="my-dialog-class custom-width">
    <div class="container">
      <el-form label-position="top" :inline="false" :rules="rules" label-width="100%" :model="selectedObject"
        ref="my-form" @submit.prevent="save" v-loading="loadingVisible">
        <el-row :gutter="15">
          <el-col :md="6">
            <el-form-item label="Id Evio" prop="IdEvio">
              <el-input class="full-width" v-model="selectedObject.IdEvio" />
            </el-form-item>
          </el-col>
          <el-col :md="6">
            <el-form-item label="Nume" prop="Nume">
              <el-input class="full-width" v-model="selectedObject.Nume" />
            </el-form-item>
          </el-col>

          <el-col :md="6">
            <el-form-item label="Centru productie" prop="IdCentruProductie">
              <el-select v-model="selectedObject.IdCentruProductie" class="full-width" @change="handleSelectCentru()">
                <el-option v-for="item in Info.centre_productie" :key="'centre_productie' + item.Id" :label="item.Nume"
                  :value="item.Id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :md="6">
            <el-form-item label="Categorie" prop="IdCategorie">
              <el-select v-model="selectedObject.IdCategorie" class="full-width">
                <el-option v-for="item in Info.categorii_produse_centru" :key="'categorii_produse' + item.Id"
                  :label="item.Nume" :value="item.Id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :md="4">
            <el-form-item label="Pret Normal">
              <el-input-number class="full-width" v-model="selectedObject.Pret" :precision="2"
                :max="999999"></el-input-number>
            </el-form-item>
          </el-col>
          <el-col :md="4">
            <el-form-item label="Pret Autoutilitar">
              <el-input-number class="full-width" v-model="selectedObject.PretAutoutilitar" :precision="2"
                :max="999999"></el-input-number>
            </el-form-item>
          </el-col>
          <el-col :md="4">
            <el-form-item label="Pret SUV">
              <el-input-number class="full-width" v-model="selectedObject.PretSUV" :precision="2"
                :max="999999"></el-input-number>
            </el-form-item>
          </el-col>
          <el-col :md="4">
            <el-form-item label="Pret Supercar">
              <el-input-number class="full-width" v-model="selectedObject.PretSupercar" :precision="2"
                :max="999999"></el-input-number>
            </el-form-item>
          </el-col>

          <el-col :md="3">
            <el-form-item label="Optiuni">
              <el-checkbox v-model="selectedObject.Serviciu" true-label="1" false-label="0">Serviciu</el-checkbox>
              <br />
              <el-checkbox v-model="selectedObject.Dezactivat" true-label="1" false-label="0">Dezactivat</el-checkbox>
              <br />
              <el-checkbox v-model="selectedObject.StorneazaValoare" true-label="1" false-label="0">Storneaza
                valoarea</el-checkbox>
            </el-form-item>
          </el-col>

          <el-col :md="5">
            <el-form-item label="Asociere Produse">
              <el-checkbox v-model="selectedObject.Asociabil" true-label="1" false-label="0">
                Asociabil
              </el-checkbox>

              <div v-if="selectedObject.Asociabil == '1'" style="margin-top: 5px;">
                <el-select v-model="selectedObject.ProduseAsociate" multiple collapse-tags filterable
                  placeholder="Alege produse..." class="full-width">
                  <el-option v-for="prod in listaProduseFiltrata" :key="'assoc_prod_' + prod.Id" :label="prod.Nume"
                    :value="prod.Id">
                    <span style="float: left">{{ prod.Nume }}</span>
                  </el-option>
                </el-select>
              </div>
            </el-form-item>
          </el-col>

          <el-col :md="6">
            <el-form-item label="Timp montaj">
              <el-input-number class="full-width" v-model="selectedObject.TimpMontaj" :step="60" :min="0"
                :max="999999"></el-input-number>
            </el-form-item>
          </el-col>
          <el-col :md="6">
            <el-form-item label="Cost montaj">
              <el-input-number class="full-width" v-model="selectedObject.CostMontaj" :step="1" :min="0" :max="999999"
                :disabled="selectedObject.TimpMontaj == 0" :precision="2"></el-input-number>
            </el-form-item>
          </el-col>
          <el-col :md="24">
            <el-form-item label="Descriere" prop="Descriere">
              <el-input type="textarea" :autosize="{ minRows: 3, maxRows: 7 }" class="full-width"
                v-model="selectedObject.Descriere" />
            </el-form-item>
          </el-col>

        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showPopup = false"> Renunta </el-button>
        <el-button type="primary" @click="save"> Salveaza </el-button>
      </span>
    </div>
  </el-dialog>
</template>

<script>
import settings from "@/backend/LocalSettings";
import BasePage from "@/pages/Admin/BasePage";

export default {
  name: "Produse_dialog",
  extends: BasePage,
  data() {
    return {
      baseUrl: "",
      showPopup: false,
      mode: "add",
      selectedObject: {
        IdEvio: "",
        IdCategorie: "",
        IdCentruProductie: "",
        Nume: "",
        Descriere: "",
        Pret: "",
        PretAutoutilitar: "",
        PretSUV: "",
        PretSupercar: "",
        Serviciu: "0",
        Dezactivat: "0",
        TimpMontaj: "",
        CostMontaj: "",
        StorneazaValoare: "0",
        Asociabil: "0",
        ProduseAsociate: []
      },
      Info: {
        categorii_produse: [],
        categorii_produse_centru: [],
        centre_productie: [],
        lista_produse: []
      },
      rules: {
        IdEvio: [{ required: true, message: "Campul este obligatoriu", trigger: 'blur' }],
        IdCategorie: [{ required: true, message: "Campul este obligatoriu" }],
        IdCentruProductie: [{ required: true, message: "Campul este obligatoriu" }],
        Nume: [{ required: true, message: "Campul este obligatoriu" }],
      },
    };
  },
  computed: {
    listaProduseFiltrata() {
      if (!this.Info.lista_produse) return [];

      if (this.mode === 'add' || !this.selectedObject.Id) {
        return this.Info.lista_produse;
      }

      return this.Info.lista_produse.filter(p => p.Id != this.selectedObject.Id);
    }
  },
  methods: {
    show_me: async function (id) {
      this.showPopup = true;
      if (id == null) {
        this.mode = "add";
        this.selectedObject = {
          IdEvio: "",
          IdCategorie: "",
          IdCentruProductie: "",
          Nume: "",
          Descriere: "",
          Pret: "",
          PretAutoutilitar: "",
          PretSUV: "",
          PretSupercar: "",
          Serviciu: "0",
          Dezactivat: "0",
          TimpMontaj: "",
          CostMontaj: "",
          StorneazaValoare: "0",
          Asociabil: "0",
          ProduseAsociate: []
        };
      } else {
        this.mode = "edit";
        var result = await this.post("admin/produse/get_info_item_dialog", {
          id: id,
        });
        this.selectedObject = result.Item;

        if (typeof this.selectedObject.ProduseAsociate === 'string' && this.selectedObject.ProduseAsociate.length > 0) {
          try {
            this.selectedObject.ProduseAsociate = JSON.parse(this.selectedObject.ProduseAsociate);
          } catch (e) {
            this.selectedObject.ProduseAsociate = this.selectedObject.ProduseAsociate.split(',');
          }
        } else if (!this.selectedObject.ProduseAsociate) {
          this.selectedObject.ProduseAsociate = [];
        }
      }
    },
    handleSelectCentru() {
      this.selectedObject.IdCategorie = '';
      this.Info.categorii_produse_centru = this.Info.categorii_produse.filter((value) => value.IdCentruProductie == this.selectedObject.IdCentruProductie)
    },
    async get_info() {
      var response = await this.post("admin/produse/get_info_for_dialog");
      this.Info.categorii_produse = response.categorii_produse;
      this.Info.categorii_produse_centru = response.categorii_produse;
      this.Info.centre_productie = response.centre_productie;

      if (response.lista_produse) {
        this.Info.lista_produse = response.lista_produse;
      }
    },
    save: async function () {
      await this.$refs["my-form"].validate(async (valid) => {
        if (valid) {
          if (this.selectedObject.Asociabil == '0') {
            this.selectedObject.ProduseAsociate = [];
          }

          await this.post("admin/produse/save", {
            mode: this.mode,
            object: this.selectedObject,
          });
          this.showPopup = false;
          this.selectedObject = {};
          this.$emit("save");
        }
      });
    },
  },
  mounted: function () {
    this.baseUrl = settings.BASE_URL;
    this.get_info();
  },
};
</script>